export default class Accessibility {
  /**
   * Traps the focus in a particular container
   */
  static trapFocus(container, namespace) {
    this.listeners = this.listeners || {};

    // We check if there is an element with the attribute "autofocus"
    var elementToFocus = container.querySelector('[autofocus]') || container;

    container.setAttribute('tabindex', '-1');
    elementToFocus.focus();

    this.listeners[namespace] = function (event) {
      if (container !== event.target && !container.contains(event.target)) {
        container.focus();
      }
    };

    document.addEventListener('focusin', this.listeners[namespace]);
  }

  /**
   * Removes the trap of focus in a particular container
   */

  static removeTrapFocus(container, namespace) {
    if (container) {
      container.removeAttribute('tabindex');
    }

    document.removeEventListener('focusin', this.listeners[namespace]);
  }

  /**
   * Reset any previous trap focus
   */

  static clearTrapFocus() {
    for (var key in this.listeners) {
      if (this.listeners.hasOwnProperty(key)) {
        document.removeEventListener('focusin', this.listeners[key]);
      }
    }

    this.listeners = {};
  }
}